const dynamicGroupsRu: DynamicGroup[] = [
  {
    id: 1,
    name: 'Брони, истекающие сегодня',
    description:
      'Выяснить возражения и либо продлить бронь, либо предложить другой вариант.',
    query:
      '([what: "Booked" & expiration: "today" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 2,
    name: 'Брони, истекающие завтра',
    description:
      'Напомнить о скором снятии брони. Попробовать назначить дату сделки, или выяснить возражения.',
    query:
      '([what: "Booked" & expiration: "1 days from now" & status: "Active"  & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 3,
    name: 'Все активные брони',
    description:
      'Мониторинг активных броней. Здесь вы увидите все брони, активные на данный момент',
    query:
      '([what: "Booked" & expiration > "today" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 4,
    name: 'Переговоры на контроле',
    description:
      'Горячие лиды, которые уже обсуждают конкретные условия. Ответить на все вопросы и назначить дату сделки.',
    query: '({lead_status: "Переговоры по конкретным квартирам"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 5,
    name: 'Позвонить повторно',
    description:
      'Лиды, последний разговор с которыми не состоялся. Перезвонить при первой возможности.',
    query: '({lead_note: "#позвонить"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 6,
    name: 'Сформировать шорт-лист домов',
    description:
      'Нужно убедиться, что наши объекты/секции действительно есть в шорт-листе клиента и он будет их рассматривать. По возможности подобрать конкретные квартиры.',
    query:
      '({lead_status: "Спрашивает по домам, отвечаем","Мониторинг цен, неконкретный" & lead_updated > "45 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 7,
    name: 'Сформировать шорт-лист квартир',
    description:
      'Нужно убедиться, что шорт-лист клиента включает конкретные квартиры из наших домов.',
    query:
      '({lead_status: "Спрашивает по квартирам, отвечаем","Есть шорт-лист домов, секций" & lead_updated > "7 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 8,
    name: 'Ввести в стадию переговоров',
    description:
      'Мы в шорт-листе, но клиент не обсуждает условия покупки. Стимулировать клиента к обсуждению условий и назначению даты сделки.',
    query:
      '({lead_status: "Есть шорт-лист квартир" & lead_updated > "3 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 9,
    name: 'Обработать ценовое возражение',
    description:
      'Убедить в ценности бюджетных вариантов, либо предложить рассрочку на желаемый объект инвестирования.',
    query:
      '({lead_status: "Отказ, желаемое - дорого" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 10,
    name: 'Не подошло местоположение',
    description:
      'Определить критичность местоположения для лида. Либо вернуть в воронку продажи, либо перенести в "Категорический отказ, местоположение"',
    query:
      '({lead_status: "Отказ, местоположение" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 11,
    name: 'Предложить альтернативы',
    description:
      'Лида не устроили параметры того, что есть в наличии. Пробуем предложить разделение/объединение или убедить пересмотреть критерии. Либо вернуть в воронку продажи, либо перенести в "Категорический отказ, ассортимент"',
    query:
      '({lead_status: "Желаемого по параметрам нет" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
];

const dynamicGroupsEn: DynamicGroup[] = [
  {
    id: 1,
    name: 'Expiring reservations',
    description:
      'Find out the objections and either renew the reservation, or suggest another option.',
    query:
      '([what: "Booked" & expiration: "today" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
  },
  {
    id: 2,
    name: 'Expiring tomorrow',
    description:
      'Remind about soon expiring reservation. Try to set a date of the deal, or find out the objections.',
    query:
      '([what: "Booked" & expiration: "1 days from now" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
  },
  {
    id: 3,
    name: 'All active reservations',
    description: 'Monitor all active reservations.',
    query: '([what: "Booked" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
  },
  {
    id: 4,
    name: 'Negotiations under control',
    description:
      'Hot leads who are already discussing specific deal terms. Answer all questions and set a date of the deal.',
    query: '({lead_status: "Negotiation"})',
    how_often: 'everyday',
  },
  {
    id: 5,
    name: 'Call again',
    description: 'Call back those leads at your earliest convenience.',
    query: '({lead_note: "#redial"})',
    how_often: 'everyday',
  },
  {
    id: 6,
    name: 'Define short-list of buildings',
    description:
      "We need to make sure that our buildings are in the lead's short-list and he/she is consider them. If possible, choose specific apartments.",
    query:
      '({lead_status: "Asks about buildings","Unspecific" & lead_updated > "45 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 7,
    name: 'Define short-list of apartments',
    description:
      "We need to make sure that the lead's short-list includes specific apartments from our buildings.",
    query:
      '({lead_status: "Asks about apartments","Has short-list of buildings" & lead_updated > "7 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 8,
    name: 'Lead to Negotiation stage',
    description:
      'We are in the short-list, but the lead does not discuss the deal terms. Stimulate the lead to discuss the terms.',
    query:
      '({lead_status: "Has short-list of apartments" & lead_updated > "3 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 9,
    name: 'Handle a price objection',
    description:
      'Convince in the viability of cheaper options, or offer to pay by installments for the desired apartment.',
    query:
      '({lead_status: "Desired is out of budget" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 10,
    name: 'Handle a location objection',
    description:
      'Determine how critical the location is for the lead. Either return to the Sales Funnel, or move to "Lost, location"',
    query: '({lead_status: "Location bad fit" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 11,
    name: 'Find alternatives',
    description:
      'Earlier we didn\'t find anything suitable by parameters. We try to propose division / consolidation or persuade to reconsider the criteria. Either return to the Sales Funnel, or move to "Lost, lack of stock"',
    query:
      '({lead_status: "Nothing suitable by parameters" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
];

const dynamicGroupsUk: DynamicGroup[] = [
  {
    id: 1,
    name: 'Бронювання до сьогодні',
    description:
      "З'ясувати заперечення, продовжити бронювання або запропонувати альтернативу.",
    query:
      '([what: "Booked" & expiration: "today" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 2,
    name: 'Бронювання до завтра',
    description:
      "Нагадати щодо бронювання. Спробувати призначити дату підписання або з'ясувати заперечення.",
    query:
      '([what: "Booked" & expiration: "1 days from now" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 3,
    name: 'Всі активні бронювання',
    description: 'Моніторинг всіх активних бронювань.',
    query: '([what: "Booked" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 4,
    name: 'Перемовини під контролем',
    description:
      'Гарячі ліди, що вже обговорюють конкретні умови. Призначити дату підписання.',
    query: '({lead_status: "Перемовини"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 5,
    name: 'Перетелефонувати',
    description: 'Передзвоніть цим лідам як тільки зможете.',
    query: '({lead_note: "#зателефонувати"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 6,
    name: 'Підібрати список будинків',
    description:
      'Ми маєво впевнитись, що наші будинки у шорт-листу потенційного клиєнта. Якщо можливо, підберіть конкретні квартири.',
    query:
      '({lead_status: "Запитує щодо будинків","Моніторинг цін, неконкретний" & lead_updated > "45 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 7,
    name: 'Підібрати список квартир',
    description:
      'Ми маєво впевнитись, що квартири з наших будинків є у шорт-листу потенційного клиєнта, що він їх розглядає.',
    query:
      '({lead_status: "Запитує щодо квартир","Має шорт-лист будинків" & lead_updated > "7 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 8,
    name: 'Підвести до перемовин',
    description:
      'Ми у шорт-листу, але лід не переходить до активних перемовин. Підвести ліда до обговорення умов придбання.',
    query:
      '({lead_status: "Має шорт-лист квартир" & lead_updated > "3 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 9,
    name: 'Опрацювати цінове заперечення',
    description:
      'Запевнити у цінності більш бюджетних варіантів або запропонувати оплату частинами за варіант, що більш до вподоби.',
    query:
      '({lead_status: "Відмова, бажане не в бюджеті" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 10,
    name: 'Опрацювати заперечення щодо розташування',
    description:
      'З\'ясувати критичніть місцерозташування ЖК для ліда. Або повернути до воронки продажу, або перемістити до "Категорична відмова, розташування"',
    query:
      '({lead_status: "Відмова, розташування" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 11,
    name: 'Підібрати альтернативи',
    description:
      'Раніше ми не змогли підібрати гарні варінти за параметрами. Пробуємо запропонувати об\'єднання / розділення квартир або зміну критеріїв. Або повернути до воронки продажу, або перемістити до "Категорична відмова, відсутність варіантів"',
    query:
      '({lead_status: "Немає бажаного за параметрами" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
];

const dynamicGroupsVi: DynamicGroup[] = [
  {
    id: 1,
    name: 'Đặt chỗ hết hạn',
    description:
      'Tìm những phản đối và làm mới đặt chỗ hoặc đề xuất lựa chọn khác.',
    query:
      '([what: "Booked" & expiration: "today" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 2,
    name: 'Hết hạn vào ngày mai',
    description:
      'Nhắc nhở những đặt chỗ sớm hết hạn. Cố gắng sắp xếp ngày giao dịch hoặc tìm những phản đối.',
    query:
      '([what: "Booked" & expiration: "1 days from now" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 3,
    name: 'Tất cả những đặt chỗ có hiệu lực',
    description: 'Giám sát tất cả đặt chỗ có hiệu lực.',
    query: '([what: "Booked" & status: "Active" & lua_type: 1])',
    how_often: 'everyday',
    is_visible_in_integration: true,
  },
  {
    id: 4,
    name: 'Đàm phán trong tầm kiểm soát',
    description:
      'Khách hàng tiềm năng đã thảo luận điều khoản cụ thể. Hãy trả lời tất cả câu hỏi và sắp xếp lịch giao dịch.',
    query: '({lead_status: "Thương lượng"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 5,
    name: 'Gọi lại',
    description: 'Gọi lại những khách hàng này khi thuận tiện nhất.',
    query: '({lead_note: "#gọi_lại_sau"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 6,
    name: 'Định nghĩa danh sách tòa nhà rút gọn',
    description:
      'Chúng ta cần chắc chắn các tòa nhà của chúng ta đang được khách hàng cân nhắc. Nếu có thể, hãy chọn những căn hộ cụ thể.',
    query:
      '({lead_status: "Hỏi về tòa nhà","Không rõ" & lead_updated > "45 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 7,
    name: 'Định nghĩa danh sách căn hộ rút gọn',
    description:
      'Chúng ta cần chắc chắn khách hàng đang cân nhắc các căn hộ cụ thể trong các tòa nhà của chúng ta.',
    query:
      '({lead_status: "Hỏi về căn hộ","Có danh sách chung cư rút gọn" & lead_updated > "7 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 8,
    name: 'Đến giai đoạn thương lượng',
    description:
      'Chúng ta đang ở danh sách rút gọn, nhưng khách hàng không bàn về điều khoản giao dịch. Hãy khiến họ thảo luận các điều khoản.',
    query:
      '({lead_status: "Có danh sách căn hộ rút gọn" & lead_updated > "3 days ago"})',
    how_often: 'twice a week',
  },
  {
    id: 9,
    name: 'Xử lý phản đối về giá',
    description:
      'Thuyết phục những lựa chọn rẻ hơn trong khả năng, hoặc đề nghị thanh toán trả góp cho căn hộ khách hàng mong muốn.',
    query:
      '({lead_status: "Mong muốn ngoài ngân sách" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 10,
    name: 'Xử lý phản đối về địa điểm',
    description:
      'Xác định tầm quan trọng về địa điểm đối với khách hàng. Hoặc chuyển về lại Phễu bán hàng, hoặc chuyển đến "Bỏ lỡ, địa điểm"',
    query:
      '({lead_status: "Địa chỉ không phù hợp" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
  {
    id: 11,
    name: 'Tìm lựa chọn thay thế',
    description:
      'Trước đây chúng ta đã không tìm thấy căn nào phù hợp với tiêu chí. Chúng ta cố gắng đề xuất tách / gộp hoặc thuyết phục khách hàng cân nhắc lại tiêu chí. Hoặc chuyển về lại Phễu bán hàng, hoặc chuyển đến "Bỏ lỡ, thiếu nguồn cung"',
    query:
      '({lead_status: "Không phù hợp tiêu chí nào" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
];

const dynamicGroupsRealtyPro: DynamicGroup[] = [
  {
    id: 1,
    name: 'В работе',
    description:
      'Лиды в статусе "Переговоры по сделке" и "Встреча состоялась, принимает решение".',
    query:
      '({lead_status: "Переговоры по сделке","Встреча состоялась, принимает решение" & lead_updated > "1 days ago"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 2,
    name: 'В работе (брони)',
    description: 'Активные устные брони на 2, 3, 5 дней.',
    query:
      '([what: "Booked" & status: "Active" & lua_type: 1]{unit_status: "Устная бронь 2 дня","Устная бронь 3 дня","Устная бронь 5 дней" & lead_updated > "1 days ago"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 3,
    name: 'Договоренность о встрече',
    description: 'Лиды в статусе "Мониторинг, планирует приехать"',
    query:
      '({lead_status: "Мониторинг, планирует приехать" & lead_updated > "1 days ago"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 4,
    name: 'Договоры бронирования',
    description: 'Активные брони по договору бронирования.',
    query:
      '([what: "Booked" & status: "Active" & lua_type: 1]{unit_status: "Договор бронирования" & lead_updated > "1 days ago"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 5,
    name: 'Позвонить повторно',
    description:
      'Лиды, последний разговор с которыми не состоялся. Перезвонить при первой возможности.',
    query: '({lead_note: "#позвонить"})',
    how_often: 'everyday',
    is_visible_in_integration: false,
  },
  {
    id: 6,
    name: 'Неконкретные',
    description: '',
    query:
      '({lead_status: "Мониторинг, неконкретный","Встреча состоялась, неконкретный" & lead_updated > "6 days ago"})',
    how_often: 'once a week',
  },
];

export function getDynamicGroups({
  locale,
  isRealtyPro = false,
}: {
  locale: string;
  isRealtyPro?: boolean;
}): DynamicGroup[] {
  switch (locale) {
    case 'ru':
      return isRealtyPro ? dynamicGroupsRealtyPro : dynamicGroupsRu;
    case 'en':
      return dynamicGroupsEn;
    case 'uk':
      return dynamicGroupsUk;
    case 'vi':
      return dynamicGroupsVi;
    default:
      return [];
  }
}

export interface DynamicGroup {
  id: number;
  name: string;
  description: string;
  query: string;
  how_often: string;
  is_visible_in_integration?: boolean;
}
